import { Button } from '@/components/ui/button'
import { Form } from '@/components/ui/form';
import { toast } from '@/components/ui/use-toast';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import * as z from 'zod';
import { useFieldArray, useForm } from 'react-hook-form';
import Counter from '@/src/common/Counter';
import DomesticPaxForm from './DomesticPaxForm';
import { zodResolver } from '@hookform/resolvers/zod';
import { useDispatch, useSelector } from 'react-redux';
import { Paths } from '@/src/constants/Paths';
import { BookFlight } from '@/src/actions/domestic/domesticFlightAction';
import { DOMESTIC, INTERNATIONAL } from '@/src/constants/flightTypes';
import { phoneRegex } from '../ReviewFlightPage';
import { useMediaQuery } from '@/hooks/use-media-query';


const globalFormSchema = z.object({
  departureAirport: z.any(),
  arrivalAirport: z.any(),
  ticket: z.array(
    z.object({
      supplier: z.any(),
      flightid: z.any(),
      ReturnFlightID: z.any(),
      headerParam: z.any(),
      ContactPerson: z.object({
        Title: z.string().min(1, { message: "Title is required" }),
        FirstName: z.string().min(1, { message: "First name is required" }),
        LastName: z.string().min(1, { message: "Last name is required" }),
        MiddleName: z.any(),
        Email: z
          .string()
          .min(1, { message: "Email is required" })
          .email({ message: "Invalid Email" }),
        ContactNo: z
          .string()
          .min(1, { message: "Contact number is required" })
          .min(10, { message: "Contact number must be 10 digits" })
          .max(10, { message: "Contact number must be less than 10 digits" })
          .regex(phoneRegex, "Invalid contact number!"),
        Nationality: z.any(),
      }),
      passenger: z.array(
        z.object({
          Title: z.string().min(1, { message: "Title is required" }),
          FirstName: z.string().min(1, { message: "First name is required" }),
          MiddleName: z.any(),
          LastName: z.string().min(1, { message: "Last name is required" }),
          PaxType: z.any(),
          Gender: z.string().min(1, { message: "Gender is required" }),
          Nationality: z.any(),
          PassengerID: z.any()
        })
      )
    })
  ),
  tripType: z.any(),
  BookingRef: z.object({
    Vendor1: z.any(),
    Vendor2: z.any(),
  })

})
const DomesticPaxInfoForm = () => {
  // temporary items
  const { holdedFlightResponse, searchForm, holdedFlight } = useSelector(state => state.flights);
  const [bookingResponseKey, setBookResponseKey] = useState(null);
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (searchForm == null || Object.keys(holdedFlightResponse).length <= 0) {
      navigate(Paths.HOME);
    };
  }, [searchForm]);
  const handlTimeUp = () => {
    navigate("/flights");
    toast({
      variant: "destructive",
      title: "Time Exceed !!",
      description: "You took too long, book again quicker.",
    });
  };

  const form = useForm({
    resolver: zodResolver(globalFormSchema),
    defaultValues: searchForm && {
      "departureAirport": searchForm.from.toLowerCase(),
      "arrivalAirport": searchForm.to.toLowerCase(),
      "ticket": [],
      "tripType": searchForm && searchForm.tripType == "1" ? "O" : "R",
      "BookingRef": {
        "Vendor1": holdedFlightResponse?.BookingRefNumbers?.PlazmaBookRef ?? "",
        "Vendor2": holdedFlightResponse?.BookingRefNumbers?.YetiBookRef ?? "",
      }
    }
    ,
  });
  const { fields, append } = useFieldArray({ control: form.control, name: "ticket" })
  useEffect(() => {
    let reservation = holdedFlightResponse.ReservationRS[0];
    let ReturnFlightID = reservation.Reservations.length > 1 && reservation.Supplier === 2 ? reservation.Reservations[1].FlightID : "";
    append({
      "supplier": reservation.Supplier.toString(),
      "flightid": reservation.Reservations[0].FlightID,
      "ReturnFlightID": ReturnFlightID,
      "headerParam": reservation.Reservations[0].HeaderParam,
      "ContactPerson": {
        "Title": "",
        "FirstName": "",
        "LastName": "",
        "MiddleName": "",
        "Email": "",
        "ContactNo": "",
        "Nationality": "NP"
      },
      "passenger": []
    })

  }, [])
  const onSubmit = (e) => {
    if (holdedFlightResponse.ReservationRS.length > 1) {
      var returnResponse = holdedFlightResponse.ReservationRS[1];
      var ticketInfo = e.ticket[0];
      e.ticket.push({
        ...ticketInfo,
        flightid: returnResponse.Reservations[0].FlightID,
        supplier: returnResponse.Supplier.toString(),
        headerParam: returnResponse.Reservations[0].HeaderParam,
      })
    }
    dispatch(BookFlight(e, (bookResp) => {
      if (bookResp.IsSuccess) {
        setBookResponseKey(bookResp.Result);
        localStorage.setItem("bookinfRef", bookResp.Result);
        localStorage.setItem('currentFlightType', DOMESTIC);
        navigate('/payment');
      }
      else if (bookResp.Result != null) {
        toast({
          variant: "error",
          title: bookResp.Message,
          description: bookResp.Result.length > 0 ? bookResp.Result.map((err) => {
            return err
          }).toString() : "Error",
        });
      }
    }))
  }
  return (
    <div className='bg-gray-100 dark:bg-background'>
      <div className='container m-auto p-0 pb-20 lg:p-4 lg:pb-4'>
        <div className='bg-orange-100 border-orange-200 border text-orange-900 p-2 text-center mb-2 rounded'>
          Flight availability is limited. Book within{" "}
          <span className='font-medium'>
            <Counter
              timeLimit={10}
              handleTimeUp={handlTimeUp}
              isDomestic
            />
          </span>
        </div>
        {searchForm && Object.keys(holdedFlightResponse).length > 0 && <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-8 bg-background rounded-lg shadow">
            <div>
              <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                  <div className="border-b  last-of-type:border-0 mb-4">
                    <div className="p-1">
                      {fields.map((field, i) => (<DomesticPaxForm plainSearchForm={searchForm} key={field.id} index={i} field={field} form={form} />))}
                    </div>
                    <div className='p-6 pt-0 flex justify-end'>
                      <Button type='submit'
                      // onClick={() => {
                      //   form.trigger();
                      // }}
                      >Submit</Button>
                    </div>

                  </div>
                </form>
              </Form>
            </div>
          </div>
          {isDesktop ? (
            <div className="col-span-12 lg:col-span-4">
              <div className="col-span-4 sticky top-3">
                <div className="bg-background rounded-lg p-3 shadow">
                  {holdedFlightResponse && holdedFlightResponse.TotalFare &&
                    <table className="w-full">
                      <thead>
                        {holdedFlightResponse.TotalFare.GrandTotalFare > 0 && (
                          <tr className="font-medium text-lg">
                            <td className="py-1">Total Fare</td>
                            <td className="text-right py-1">
                              {holdedFlightResponse.TotalFare.Currency} {holdedFlightResponse.TotalFare.GrandTotalFare}
                            </td>
                          </tr>
                        )}
                      </thead>
                      <tbody className="text-muted-foreground text-sm">
                        <tr>
                          <td className="py-1">Total Base Fare</td>
                          <td className="text-right py-1">
                            {holdedFlightResponse.TotalFare.Currency} {holdedFlightResponse.TotalFare.TotalBaseFare}
                          </td>
                        </tr>

                        {holdedFlightResponse.TotalFare.TotalTax > 0 && (
                          <tr>
                            <td className="py-1">Total TAX</td>
                            <td className="text-right py-1">
                              {holdedFlightResponse.TotalFare.Currency} {holdedFlightResponse.TotalFare.TotalTax}
                            </td>
                          </tr>
                        )}
                        {holdedFlightResponse.TotalFare.Discount > 0 && (
                          <tr>
                            <td className="py-1">Total TAX</td>
                            <td className="text-right py-1">
                              {holdedFlightResponse.TotalFare.Currency} {holdedFlightResponse.TotalFare.Discount}
                            </td>
                          </tr>
                        )}
                        {holdedFlightResponse.TotalFare.ServiceCharge > 0 && (
                          <tr>
                            <td className="py-1">Total TAX</td>
                            <td className="text-right py-1">
                              {holdedFlightResponse.TotalFare.Currency} {holdedFlightResponse.TotalFare.ServiceCharge}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  }
                  {/* {PricingInfo.Fare.FareBreakDowns?.length > 0 && <FareBreakdown fareBreakdowns={PricingInfo.Fare.FareBreakDowns} />} */}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>}
      </div>
    </div >
  )
}

export default DomesticPaxInfoForm
